import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';

@Injectable({ providedIn: 'root' })
export class InvestmentsFormProvider {
  investmentForm: FormGroup;

  constructor(private fb: FormBuilder) {}

  initInvestmentForm(data?: any): FormGroup {
    return (this.investmentForm = this.fb.group({
      investorId: [data?.investorId, [Validators.required]],
      ccy: [data?.ccy || '', [Validators.required]],
      faceValue: [+data?.faceValue || '', [Validators.required, Validators.min(0.01)]],
      months: [data?.months, [Validators.required]],
      type: [data?.type || '', [Validators.required]],
      comments: [data?.comments],
      transactionType: ['', [Validators.required]],
      product: [data?.product || '', [Validators.required]],
      date: [data?.date || moment().format('YYYY-MM-DD'), [Validators.required]],
    }));
  }
}
